module.exports = __webpack_public_path__ + "static/media/video.8b7e217b.jpg";